import React from 'react'
import Theme from '@refera/ui-core'
import { format } from 'date-fns'
import { IconButton } from '@mui/material'
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined'

import Svg from '_components/svg'
import TickIcon from '_assets/icons/ic-tick-circle.svg'
import InfoIcon from '_assets/icons/ic-info-circle.svg'
import CloseIcon from '_assets/icons/ic-close-circle.svg'

import useStyles from './styles'

const TYPE_OPTIONS = {
  retirada: { label: 'Retirada', color: Theme.Colors.Yellow.Base, icon: InfoIcon },
  devolucao: { label: 'Devolução', color: Theme.Colors.Green.Base, icon: TickIcon },
}

const TypeCell = ({ type }) => {
  const styles = useStyles()
  const { color, icon } = TYPE_OPTIONS[type]
  return (
    <div className={styles.icon}>
      <Svg icon={icon} style={{ color }} />
    </div>
  )
}

const ActiveCell = ({ active }) => {
  const styles = useStyles()

  if (active) {
    return (
      <div className={styles.icon}>
        <Svg icon={TickIcon} />
      </div>
    )
  }
  return (
    <div className={styles.icon}>
      <Svg icon={CloseIcon} />
    </div>
  )
}

export const AttachmentCell = ({ value, setOpenModal, setAttachments, uuid }) => {
  const styles = useStyles()

  if (value?.length > 0) {
    return (
      <div className={styles.icon}>
        <IconButton
          onClick={event => {
            event.stopPropagation()
            setAttachments([{ id: uuid, file: value }])
            setOpenModal(true)
          }}
        >
          <PhotoLibraryOutlinedIcon
            style={{
              width: 20,
              height: 20,
              color: Theme.Colors.Primary.Base,
            }}
          />
        </IconButton>
      </div>
    )
  }
  return null
}

export const COLUMNS = [
  {
    field: 'type',
    headerName: 'Tipo de registro',
    width: 150,
    editable: false,
    renderCell: ({ value }) => <TypeCell type={value} />,
  },
  {
    field: 'budget',
    headerName: 'Orçamento',
    width: 150,
    editable: false,
  },
  {
    field: 'isActiveBudget',
    headerName: 'Ativo',
    width: 100,
    editable: false,
    renderCell: ({ value }) => <ActiveCell active={value} />,
  },
  {
    field: 'companyName',
    headerName: 'Prestador',
    editable: false,
    flex: 1,
  },
  {
    field: 'action',
    headerName: 'Ação',
    width: 150,
    editable: false,
    renderCell: ({ row }) => {
      const option = TYPE_OPTIONS[row.type]
      return option ? option?.label : ''
    },
  },
  {
    field: 'dateAndTimeKeyAction',
    headerName: 'Data/hora',
    width: 180,
    editable: false,
    renderCell: ({ value }) => {
      if (!value) return null
      const date = new Date(value)
      return format(date, "dd/MM/yyyy 'às' HH:mm")
    },
  },
  {
    field: 'attachment',
    headerName: 'Anexos',
    width: 100,
    editable: false,
    renderCell: ({ value }) => AttachmentCell({ value }),
  },
]
